module.exports = __webpack_public_path__ + "img/course-1-3.6aff34db.jpeg";